//#region Util Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { ColumnModel } from '../../api/api.models'

import { LocalDictionaryFactory } from '../../api/api.module'

import { HistorySource } from '../../common/history/history.directive.controller'

import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridController, GridDataSourceType, GridOptions, GridTypes } from '../../common/grid'
import { LoggerService } from '../../common/common.module'

import {
    ConfigHelper, EventsNames,
    OperatorLayoutSettings, LocalizationHelper, TemplateHelper, CommonHelper, ConvertHelper, ToastHelper
} from '../../../helpers/'

import { Activity, Enums } from '../../../models/common/'
import { OpDataTypeInGroup, OpDepositoryElement, OpPackage, OpDevice, OpArticle } from '../../../models/core/'
import { OpRelatedObjects } from '../../../models/custom/'

import { SystemService } from '../../../services/system'
import { PackageContentService, PackageService, PackageRelatedOrdersService } from '../../../services/package'
import { UserSessionService } from '../../../services/user-session'

import { PackagesHelper } from '../packages.helper'
import { GridBridge } from '../../common/common.interfaces'
import { ColumnInfo } from '../../../models/custom'
import { PackageConfirmOpitons, IPackageConfirm } from '../components/package-confirm/package-confirm.interfaces'

interface PackageDetailsScope extends DetailsScope {
    id: number
    confirmButtonOptions: DevExpress.ui.dxButtonOptions
    packageContentEditButtonOptions: DevExpress.ui.dxButtonOptions
    canConfirm: boolean
    isEditAllowed: (e) => boolean
    PACKAGE_CONTENT_ACCORDION_NAME: string
}

export class PackageDirectiveController extends Details<PackageDetailsScope> {

    //#region Consts

    public get PACKAGE_COMMON_TAB_NAME() { return 'PACKAGE_COMMON_TAB_NAME' }
    public get PACKAGE_HISTORY_TAB_NAME() { return 'PACKAGE_HISTORY_TAB_NAME' }
    public get PACKAGE_PARAMS_ACCORDION_NAME() { return 'PACKAGE_PARAMS_ACCORDION_NAME' }
    public get PACKAGE_RELATED_ORDERS_ACCORDION_NAME() { return 'PACKAGE_RELATED_ORDERS_ACCORDION_NAME' }
    public get PACKAGE_CONTENT_ACCORDION_NAME() { return 'PACKAGE_CONTENT_ACCORDION_NAME' }

    private get PACKAGE_CONTENT_GRID_NAME(): string { return 'PACKAGE_DETAILS_CONTENT_GRID_NAME' }
    private get PACKAGE_CONTENT_GRID_EDIT_NAME(): string { return 'PACKAGE_CONTENT_GRID_EDIT_NAME' }
    private get PACKAGE_HISTORY_NAME(): string { return 'PACKAGE_HISTORY_NAME' }
    private get RELATED_ORDERS_GRID_NAME(): string { return 'PACKAGE_DETAILS_RELATED_PACKAGES_GRID_NAME' }

    //#endregion


    //#region Members

    public contentGridOptions: GridOptions
    public detailsParametersOptions: DetailsParametersOptions
    public packagesHistoryOptions: HistorySource
    public packageContentGridEditOptions: GridBridge
    public packageConfirmGridOptions: GridOptions
    public relatedOrdersGridOptions: GridOptions
    public confirmPackageOptions: PackageConfirmOpitons
    public deleteConfirmationOptions: {
        title: string
        onConfirmed: () => void
    }

    private confirmGridDataSourceObjects: OpDepositoryElement[]
    private doneButton: DevExpress.ui.dxButton
    private packageConfirm: IPackageConfirm
    private packageContentEditButton: DevExpress.ui.dxButton
    private packageContentGrid: GridController<OpDepositoryElement>
    private packageId: number
    private pckage: OpPackage
    private origPackage: OpPackage
    private relatedPackagesGrid: GridController<OpPackage>


    //#endregion


    // #region Ctor

    constructor(
        $scope: PackageDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        protected userSessionService: UserSessionService,
        private packageService: PackageService,
        private packageContentService: PackageContentService,
        private packageRelatedOrdersService: PackageRelatedOrdersService,
        private systemService: SystemService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.ContactPopupTabActive, userSessionService, referenceType)

        this.initializeConfirmationsOptions()
        this.setEvents()
        this.setOptions()

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    // #endregion


    // #region Events

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options

        this.packageId = options.referenceObjectId

        this.onClear()
        this.onRefresh()
        this.showPopup()
    }

    private onRefresh(toRefresh: OpPackage = null): void {
        if (!toRefresh) {
            this.packageService
                .getPackage(this.packageId)
                .then((order: OpPackage) => {
                    this.initialize(order)
                })
                .fail(() => {
                    this.hidePopup()
                })
        } else {
            this.initialize(toRefresh)
        }
    }

    private onEditOrderParams(): void {
        const createEditInitParams: CreateEditInitParams = PackagesHelper.getCreateEditOptions(this.userSessionService, this.pckage.idPackage, this.pckage)
        this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    private onClear(): void {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.pckage = null
        this.origPackage = null
        this.detailsParametersOptions = null

        this.relatedOrdersGridOptions = null
        this.relatedPackagesGrid = null

        this.contentGridOptions = null
        this.packageContentGrid = null
    }

    private onClose(): void {
        this.hidePopup()
    }

    private onDeletePackage(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onConfirmDelete(): void {
        this.packageService
            .deletePackage(this.pckage)
            .then(() => {
                this.onClose()
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
    }

    // #endregion


    //#region Component

    private initialize(pckage: OpPackage): void {
        if (pckage != null && (!this.pckage || this.pckage.idPackage == pckage.idPackage)) {
            OpDepositoryElement
                .loadNavigationProperties(this.userSessionService.getDataProvider(), pckage.contentList)
                .then(() => {
                    this.pckage = pckage
                    this.origPackage = new OpPackage(null)
                    this.origPackage.copy(pckage, true, true, true, true)

                    this.$scope.popupTitle = pckage.toString()

                    this.initializeConfirm(pckage.contentList)
                    this.initializeBasicParameters(pckage)
                    this.initializeRelatedPackages(pckage.relatedPackageList)
                    this.initializeContent(pckage.contentList)
                    this.initializeHistory(pckage)
                    this.setPackageConfirmComponentOptions(pckage)

                    this.$scope.showTabs = true
                })
        }
    }

    //#endregion


    //#region Content

    private initializeContent(contentList: OpDepositoryElement[]): void {
        this.initializePackageContentGrid(contentList)
        this.initializePackageContentGridEdit(contentList)
        this.initializeContentEditButtonOptions()
    }

    private initializePackageContentGrid(contentList: OpDepositoryElement[]) {

        if (this.packageContentGrid != null) {
            this.packageContentGrid.setDataSource(contentList)
        } else {
            this.contentGridOptions = {
                addCustomFilters: true,
                dataSourceType: GridDataSourceType.Properties,
                columnsDictionary: this.packageContentService.getPackageContentColumns(false),
                dataSource: contentList,
                name: this.PACKAGE_CONTENT_GRID_NAME,
                type: GridTypes.PAGINATED_SMALL,

                allowColumnReordering: !this.userSessionService
                    .getLoggedOperator()
                    .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageContent),

                buttonsOptions: {
                    enabled: true
                },

                onInitialized: (e: any, grid: GridController<OpDepositoryElement>) => {
                    this.packageContentGrid = grid
                },
            }
        }
    }

    private initializePackageContentGridEdit(contentList: OpDepositoryElement[]): void {
        //this.mapSerialNbrToExternalSn(contentList)
        this.packageContentService
            .getDeviceColumns()
            .then((columns: ColumnModel[]) => {
                this.packageContentGridEditOptions = {
                    id: this.pckage.idPackage,
                    columns: columns,
                    items: contentList,
                    name: this.PACKAGE_CONTENT_GRID_EDIT_NAME,
                    popupId: this.$scope.detailsPopupId + this.PACKAGE_CONTENT_GRID_EDIT_NAME,
                    title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDIT_CONTENT, this.moduleName),
                    allowDublicatedRow: false,
                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageContent),
                    getAvailableDataSourceMethod: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) =>
                        this.getGridEditData(columns, pageNbr, pageSize, customWhereClause),
                    onSubmit: (added: any[], removed: any[], inGrid: any[]) => {
                        return this.onSubmitClick(added, removed, inGrid, contentList)
                    },
                    onCellPrepared: (options: any) => {
                        this.getEditIconInCell(options, ['notes', 'externalSn'])
                    },
                    onBeforeAddAll: (gridObjects: any[]) => {
                        return this.onBeforeAddAll(gridObjects)
                    },
                }
            })
    }

    private mapSerialNbrToExternalSn(contentList: OpDepositoryElement[]): OpDepositoryElement[] {
        return contentList.map((depoElement: OpDepositoryElement) => {
            if (depoElement.serialNbr != null) {
                depoElement.externalSn = depoElement.serialNbr.toString()
            }
            return depoElement
        })
    }

    private onBeforeAddAll(gridObjects: any[]): JQueryPromise<any[]> {
        const articlesSerialNumbers: number[] = _.size(gridObjects) > 0 ? gridObjects.map((gridObject: any) => gridObject.id) : []
        return this.userSessionService
            .getDataProvider()
            .Article
            .getArticlesBySerialNumbers(articlesSerialNumbers)
            .then((releatedObjects: OpRelatedObjects[]) => {
                return this.beforeAdd(releatedObjects)
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                ToastHelper.showError(errorMsg)
            })
    }

    private getEditIconInCell(options: any, dataFields: string[]) {
        dataFields.forEach((dataField: string) => {
            this.packageContentService.getEditIconInCell(options, dataField)
        })
    }

    private beforeAdd(relatedObjects: OpRelatedObjects[]): OpDepositoryElement[] {
        return relatedObjects.map((obj: OpRelatedObjects) => {

            const depositoryElement: OpDepositoryElement = new OpDepositoryElement(null)
            const device: OpDevice = obj.referenceValue
            const article: OpArticle = obj.relatedReferenceValues[0]

            depositoryElement[CommonHelper.idField] = device.idObject
            depositoryElement.externalSn = device.serialNbr.toString()
            depositoryElement.serialNbr = device.serialNbr
            depositoryElement.opState = device.opState
            depositoryElement.article = article

            return depositoryElement
        })
    }

    private onSubmitClick(added: any[], removed: any[], inGrid: any[], contentList: OpDepositoryElement[]): ng.IPromise<boolean> {
        const defer: ng.IDeferred<boolean> = this.$q.defer<boolean>()
        this.packageContentService
            .onPackageContentSubmit(added, removed, inGrid, contentList, this.origPackage)
            .then((pack: OpPackage) => {
                if (pack != null) {
                    this.onRefresh()
                    defer.resolve(true)
                }
                else {
                    defer.resolve(false)
                }
            })
            .fail((error: any) => {
                defer.resolve(false)
            })
        return defer.promise
    }

    private onEditPackageContent(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.detailsPopupId + this.PACKAGE_CONTENT_GRID_EDIT_NAME, 'packageContentColumns')
    }

    private onEditConfirmContent(): void {
        if (this.packageConfirm != null && this.pckage != null) {
            this.packageConfirm.updateDataSource(this.pckage)
        }
        this.packageConfirm.show()
    }

    private getGridEditData(columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string): JQueryPromise<any> {
        return this.packageService.getGridEditData(columns, pageNbr, pageSize, customWhereClause)
    }

    //#endregion


    //#region Package Confirm

    private handleConfirmSubmitButton(isDisabled: boolean): void {
        this.packageConfirm.handleConfirmSubmitButton(isDisabled)
    }

    private initializeConfirm(contentList: OpDepositoryElement[]) {
        this.confirmGridDataSourceObjects = contentList
        this.initializeConfirmButtonOptions(contentList)
    }

    private contentReady(): void {
        this.handleConfirmSubmitButton(this.packageService.isEverythingAccepted(this.confirmGridDataSourceObjects))
    }

    private setPackageConfirmComponentOptions(pckage: OpPackage): void {
        this.confirmPackageOptions = {
            packToConfirm: pckage,

            onInitialized: (packageConfirmInterface: IPackageConfirm) => {
                this.packageConfirm = packageConfirmInterface
            },
            contentReady: () => this.contentReady(),
            onPackageConfirmed: () => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CONFIRMED, this.moduleName))
                this.onRefresh()
            }
        }
    }

    // #endregion


    //#region History

    private initializeHistory(pckage: OpPackage): void {
        this.packagesHistoryOptions = {
            dataMethodName: null,
            id: null,
            name: this.PACKAGE_HISTORY_NAME,
            referenceType: this.referenceType,
            referenceValue: pckage.idPackage,
            allowColumnReordering: !this.userSessionService
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageHistory),
        }
    }

    //#endregion


    //#region Parameters

    private initializeBasicParameters(result: OpPackage): void {
        this.packageService
            .getBasicParametrsDataTypeGroup()
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.detailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: this.pckage,
                    useDynamicValues: true
                }
            })
    }

    //#endregion


    //#region Related Orders

    private initializeRelatedPackages(packages: OpPackage[]): void {
        if (this.relatedPackagesGrid != null) {
            this.relatedPackagesGrid.setDataSource(packages)
        } else {
            this.packageRelatedOrdersService
                .getRelatedOrdersColumns()
                .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                    this.relatedOrdersGridOptions = {
                        addCustomFilters: true,
                        columnsDictionary: columns,
                        defaultColumnsDictionary: defaultColumns,
                        dataSource: packages,
                        idReferenceType: this.referenceType,
                        name: this.RELATED_ORDERS_GRID_NAME,
                        type: GridTypes.PAGINATED_SMALL,

                        allowColumnReordering: !this.userSessionService
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageAssociatedOrders),

                        buttonsOptions: {
                            enabled: true
                        },

                        onInitialized: (e: any, grid: GridController<OpPackage>) => {
                            this.relatedPackagesGrid = grid
                        },

                        onRowDoubleClick: () => {
                            this.openRelatedPackageDetails(this.relatedPackagesGrid.selectedItem)
                        }
                    }
                })
        }
    }

    private openRelatedPackageDetails(relatedPackage: OpPackage) {
        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ORDER_LIST)) {
            this.systemService.openDetails({
                moduleName: Enums.SimaxModuleName.Order,
                referenceObjectId: relatedPackage.idPackage
            })
        }
    }

    //#endregion


    //#region Setup

    public getAccordions(): any[] {
        const accordions: DetailsAccordion[] = []
        let items: DetailsAccordionSection[] = []

        if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageParameters)
            || !this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageAssociatedOrders)
        ) {
            items = []

            if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageParameters)) {
                items.push({
                    name: this.PACKAGE_PARAMS_ACCORDION_NAME,
                    showInTab: this.PACKAGE_COMMON_TAB_NAME,
                    showStatus: false,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Parameters),
                    visible: true,
                    canEdit: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_EDIT)
                        && !this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.PackageParameters),

                    editMethod: () => this.onEditOrderParams(),
                })
            }

            if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageAssociatedOrders)) {
                items.push({
                    name: this.PACKAGE_RELATED_ORDERS_ACCORDION_NAME,
                    showInTab: this.PACKAGE_COMMON_TAB_NAME,
                    showStatus: true,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RelatedOrders),
                    visible: true,
                    canEdit: false
                })
            }

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.PackageDetailsAccordions, 0, items, true, (component: DevExpress.ui.dxAccordion) => {
                this.$timeout(() => {
                    component.expandItem(1)
                })
            }))
        }

        if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageContent)) {
            items = []

            items.push({
                name: this.PACKAGE_CONTENT_ACCORDION_NAME,
                showInTab: this.PACKAGE_COMMON_TAB_NAME,
                showStatus: true,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PackageContent),
                visible: false,
                canEdit: false,
                editMethod: () => this.onEditPackageContent()
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.PackageDetailsAccordions, 1, items))
        }

        return accordions
    }

    public getTabs(): any[] {
        const tabs: any[] = []

        if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageParameters)
            || !this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageAssociatedOrders)
            || !this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageContent)
        ) {
            tabs.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common),
                    ConfigHelper.Icon.HOME,
                    this.userSessionService
                ),
                name: this.PACKAGE_COMMON_TAB_NAME
            })
        }

        if (!this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DETAILS_HIDDEN_UI_PROPERTIES, Enums.UIObjectProperties.PackageHistory)) {
            tabs.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History),
                    ConfigHelper.Icon.HISTORY,
                    this.userSessionService
                ),
                name: this.PACKAGE_HISTORY_TAB_NAME
            })
        }

        return tabs
    }

    private initializeConfirmationsOptions(): void {
        this.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
            delHasPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DEL) ? Activity[Activity.PACKAGE_DEL] : null,
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => this.onDeletePackage(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => this.updateAccordions(names)
        }
    }

    private initializeConfirmButtonOptions(contentList: OpDepositoryElement[]): void {
        this.$scope.PACKAGE_CONTENT_ACCORDION_NAME = this.PACKAGE_CONTENT_ACCORDION_NAME
        if (this.$scope.confirmButtonOptions != null) {
            this.doneButton.option('visible', this.isDoneButtonVisible(contentList))
        }
        this.$scope.confirmButtonOptions = {
            onInitialized: (e: any) => {
                this.doneButton = e.component
            },
            icon: "check",
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            visible: this.isDoneButtonVisible(contentList),
            onClick: (e: any) => {
                this.onEditConfirmContent()
            }
        }
    }

    private isDoneButtonVisible(contentList: OpDepositoryElement[]): boolean {
        return _.size(contentList) > 0 ? this.canEdit(Enums.PackageStatus.Sent) : false
    }

    private initializeContentEditButtonOptions() {
        if (this.packageContentEditButton != null) {
            this.packageContentEditButton.option('visible', this.canEdit(Enums.PackageStatus.New))
        }
        this.$scope.packageContentEditButtonOptions = {
            onInitialized: (e: any) => {
                this.packageContentEditButton = e.component
            },
            icon: "edit",
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            visible: this.canEdit(Enums.PackageStatus.New),
            onClick: (e: any) => this.$scope.editClick(e)
        }
    }

    private canEdit(status: Enums.PackageStatus): boolean {
        return this.pckage != null && this.pckage.idPackageStatus != null && (this.pckage.idPackageStatus === status || this.pckage.idPackageStatus === Enums.PackageStatus.Wrong)
    }

    //#endregion

    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(null) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}